module.exports = __webpack_public_path__ + "static/media/rhinogram-logo--notext.28bab428.svg";